import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import { CONTEXT_GET_HISTORIQUE_ARMES } from '../../constants/apiUrls.constants';
import { HistoriqueLoaderReducer } from './loader/historiqueLoaderReducer';

const recherche = combineReducers({
    armes: APIReducer.bind(null, CONTEXT_GET_HISTORIQUE_ARMES),
    armeLoader: HistoriqueLoaderReducer,
});

export default recherche;
